import React from "react";
import "./Home.css";
import "./Seo.css";
import Product from "./Product";
import Footer from "./Footer";
import { InfoSection } from './components';
import { homeObjOne, homeObjTwo, homeObjThree, homeObjFour, homeObjFive, homeObjSix, homeObjSeven, homeObjEight, homeObjNine } from './components/Data';
import { Link } from "react-router-dom";
import { Button } from './globalStyles';
import { useStateValue } from "./StateProvider";
import VirtualDiagnostic from "./VirtualDiagnostic";
import Youtube from "./Youtube";
import ReactCardFlipper from "react-card-flipper";
import flag from "./components/images/flag.jpg";


function Seo() {
   

    const [{ basket, user }, dispatch] = useStateValue();
  
    const getstart = () => {
      alert("Lets get started") 
     }
return (
  <div className="home" >
    <div >
  


<InfoSection {...homeObjNine} />
<h3>How a virtual diagnostic works</h3>
  <div className="box" >
      <ReactCardFlipper  display="flex" width="100%" height="620px" behavior="click" levitate={true} >
        <div >
          <h3>Step 1 (click here) </h3>
          <h3>Have Basic Tools Ready</h3>
          <h3>Please have all the necessary tools ready for your appoinment, if you do not have these tools on hand you can click on the links.</h3>
         
        </div>
        <div  >
        <h3>Step 1</h3>
        <p> A towel, small plastic container for screws etc.
a phillips head screwdriver #2 tip
a flat head screwdriver 
a socket set or nut drivers
a flashlight
pliers batteries for your meter!  
putty/spackle knife prefer metal 1.5"</p>
<p>Either Multi-Meter or preferably Clamp Meter ($15-25) (If you already have a multimeter, either works fine)</p>
<div >
<iframe className="productlink" scrolling="no" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ac&ref=tf_til&ad_type=product_link&tracking_id=airpod-20&marketplace=amazon&amp;region=US&placement=B07VB4ZRPN&asins=B07VB4ZRPN&linkId=4e0c8ab52851a0f54f47c63e77ffdbc7&show_border=false&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=d6d6d6"></iframe>
<iframe className="productlink" scrolling="no" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ac&ref=tf_til&ad_type=product_link&tracking_id=airpod-20&marketplace=amazon&amp;region=US&placement=B01NCJTSW7&asins=B01NCJTSW7&linkId=3efcce30870659632a468dbb893ec936&show_border=false&link_opens_in_new_window=true&price_color=fffcfc&title_color=ffffff&bg_color=a7b0c4"></iframe>
<iframe className="productlink" scrolling="no" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ac&ref=tf_til&ad_type=product_link&tracking_id=airpod-20&marketplace=amazon&amp;region=US&placement=B000I1QEDI&asins=B000I1QEDI&linkId=2e60fc5c60d52a24b85e210ed1df63fe&show_border=false&link_opens_in_new_window=true&price_color=fffcfc&title_color=ffffff&bg_color=a7b0c4"></iframe>
<iframe className="productlink" scrolling="no"  src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ac&ref=tf_til&ad_type=product_link&tracking_id=airpod-20&marketplace=amazon&amp;region=US&placement=B07G9X19G1&asins=B07G9X19G1&linkId=2b926eb5f9fd9937e55b98226173a454&show_border=false&link_opens_in_new_window=true&price_color=fffcfc&title_color=ffffff&bg_color=a7b0c4"></iframe>
</div>


<p>*Meter advice – If you just purchased a meter for this leave it unopened until your tech directs you to open it so that it can be returned if not needed.</p>
        </div>
        
      </ReactCardFlipper>
    </div>


    
  <div className="box" >
      <ReactCardFlipper  display="flex" width="100%" height="400px" behavior="click" levitate={true} >
        <div >
          <h3>Step 2 (click here)</h3>
          <h3>Download App annd have a stable connection for video.</h3>
          <img className="logoimg" src="https://imgur.com/L0n3MhL.png" />
        </div>
        <div>
        <h3>Step 2</h3>
       
       <p>Ensure the internet connection you are using for your video chat session has enough bandwidth. Others in the home that are also using your internet service may interfere with the video quality of the repair session if they are using demanding online activities such as gaming,  movie streaming, or downloading large files.</p>
       <p>If your video is not good it is ok we can still help with a phone call but for optimal service video is needed for the technician to assess appliance diansotic</p>
        </div>
        
      </ReactCardFlipper>
    </div>




    
    <div className="box" >
      <ReactCardFlipper  display="flex" width="100%" height="400px" behavior="click" levitate={true} >
        <div >
          <h3>Step 3 (click here)</h3>
          <h3>Make an appointment that's convenient for you</h3>
          <img className="logoimg" src="https://imgur.com/L0n3MhL.png" />
          <a className="bookapp"  href="https://square.site/book/G0YD0RWBNZJBG/7-cities-appliance">Book Virtual Appointment Now</a>
        </div>
        <div>
        <h3>Step 3</h3>
        <h3>Our scheduling site is easy to use</h3>
        <h3>Get started for only $49 </h3>
                     <a className="bookapp"  href="https://square.site/book/G0YD0RWBNZJBG/7-cities-appliance">Book Virtual Appointment Now</a>
        </div>
        
      </ReactCardFlipper>
    </div>







      <div >
    
<h3>Things to keep in mind
Know the location of your breaker panel.
In most cases you should be able to unplug the appliance during the repair for safety.
Keep all small children and pets in a safe location away from you during the Virtual Diagnostic or repair.
</h3>


<h3>VIRTUAL DIAGNOSTIC
We will take a look at the unit you are having a problem with.  Once we figure out what is wrong you will have the option to order parts to your home or if local have a technician do in-home repair.  Calls could take up to an hour, so please make sure you have time to complete the call.  We are working on expanding our service are please continue to check-in for updates.
</h3>
<h3>Virtual Diagnostic to DIY Part Installation
After your virtual  diagnostic, your  technician can  guide you through a part installation and repair. Virtual calls for installation and repair will carry an additional fee.  We also work with local parts vendors if you want to run to the store for parts and schedule video chat and complete the repair. Or you can order the parts through our partners and have them delivered to your home.
</h3>
<h3>Virtual Diagnostic to in-home repair.  
After diagnostic with your virtual technician if it is found you need a professional to come to your home to complete the repair.  We are there!   You can schedule the needed appointment. The technician will be able to arrive with parts.  This will save time from how we used to do things and allow us to have parts on hand sooner.
</h3>
      </div>
      <Footer />
    </div>
  </div>
);
}

export default Seo
